import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import { Filters } from '../'

export const ReviewsFilters: FunctionComponent = () => {
  const { state } = useContext(ReviewsTemplateContext)
  const { filters, productsWithPagination, needsBasedFilters } = state.productListingPageData

  return (
    <Filters
      data-testid="product-filters"
      filters={filters}
      productCount={productsWithPagination.productCount}
      needsBasedFilters={needsBasedFilters}
    />
  )
}
